import { RouteLocation, RouteRecordRaw } from "vue-router";

import DummyRouterView from "@/components/structure/DummyRouterView.vue";
import usePermissions from "@/hooks/use-permissions";
import AbtestFormPage from "@/pages/games/GameDisplay/children/abtests/AbtestForm/AbtestFormPage.vue";
import AbtestReviewPage from "@/pages/games/GameDisplay/children/abtests/AbtestReview/AbtestReviewPage.vue";
import AbtestsListPage from "@/pages/games/GameDisplay/children/abtests/AbtestsList/AbtestsListPage.vue";
import CohortFormPage from "@/pages/games/GameDisplay/children/abtests/CohortsList/children/CohortForm/CohortFormPage.vue";
import CohortsListPage from "@/pages/games/GameDisplay/children/abtests/CohortsList/CohortsListPage.vue";
import AddClassesFormPage from "@/pages/games/GameDisplay/children/abtests/DynamicTreatment/children/AddClassesFormPage.vue";
import CopyClassesFormPage from "@/pages/games/GameDisplay/children/abtests/DynamicTreatment/children/CopyClassesFormPage.vue";
import DynamicTreatmentPage from "@/pages/games/GameDisplay/children/abtests/DynamicTreatment/DynamicTreatmentPage.vue";

import links from "./links";

const { canReadAbtests, canWriteAbtests } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "",
    component: AbtestsListPage,
    name: links.games.abtests.list,
    props: true,
    meta: {
      title: "A/B Tests",
      permission: canReadAbtests,
    },
  },
  {
    path: "new",
    component: DummyRouterView,
    props: true,
    children: [
      {
        path: "",
        component: AbtestFormPage,
        name: links.games.abtests.new,
        props: true,
        meta: {
          title: "New A/B Test",
          permission: canWriteAbtests,
        },
      },
    ],
  },
  {
    path: ":abtestId/edit",
    component: DummyRouterView,
    props: true,
    children: [
      {
        path: "",
        component: AbtestFormPage,
        name: links.games.abtests.edit,
        props: true,
        meta: {
          title: "Edit A/B Test",
          permission: canWriteAbtests,
        },
      },
      {
        path: "dynamic-treatment",
        component: DynamicTreatmentPage,
        name: links.games.abtests.dynamicTreatment,
        props: true,
        meta: {
          title: "Dynamic Treatment",
          permission: canWriteAbtests,
        },
      },
      {
        path: "add-classes",
        component: AddClassesFormPage,
        name: links.games.abtests.addClasses,
        props: true,
        meta: {
          title: "Classes",
          permission: canWriteAbtests,
        },
      },
      {
        path: "copy-classes",
        component: CopyClassesFormPage,
        name: links.games.abtests.copyClasses,
        props: true,
        meta: {
          title: "Copy Classes",
          permission: canWriteAbtests,
        },
      },
      {
        path: "cohorts",
        component: CohortsListPage,
        name: links.games.abtests.cohorts.list,
        props: true,
        meta: {
          title: "Cohorts",
          permission: canReadAbtests,
        },
        children: [
          {
            path: "new",
            component: CohortFormPage,
            name: links.games.abtests.cohorts.new,
            props: true,
            meta: {
              title: "New cohort",
              permission: canWriteAbtests,
            },
          },
          {
            path: ":cohortId/edit",
            component: CohortFormPage,
            name: links.games.abtests.cohorts.edit,
            props: true,
            meta: {
              title: "Edit cohort",
              permission: canWriteAbtests,
            },
          },
          {
            path: ":cohortId/duplicate",
            component: CohortFormPage,
            name: links.games.abtests.cohorts.duplicate,
            props: (route: RouteLocation) => ({ ...route.params, duplicate: true }),
            meta: {
              title: "Duplicate cohort",
              permission: canWriteAbtests,
            },
          },
        ],
      },
      {
        path: "review",
        component: AbtestReviewPage,
        name: links.games.abtests.review,
        props: true,
        meta: {
          title: "Review A/B Test",
          permission: canReadAbtests,
        },
      },
    ],
  },
];
